<template>
    <div class="resumeStatus">
        <div class="statusTxt">
            <!-- <h1>状态栏</h1> -->
            <el-popover placement="top-start" width="300" trigger="hover" class="explain"
                content="简历未公开时，仅支持自己查看。简历已公开时，支持企业HR和系统管理员查看部分信息。想公开简历？完成简历必填项，即可公开/投递简历">
                <span slot="reference"><i class="el-icon-question"></i></span>
            </el-popover>

            状态：
            <span class="workStatus">
                <span v-if="baseInfo.publicStatus && baseInfo.publicStatus===true">简历已公开</span>
                <span v-else>简历未公开</span>

                <span>{{ dictFormatter(jobStatusOptions, baseInfo.jobStatus) }}</span>
            </span>
            <span class="upDataTime" v-if="baseInfo.updateTime">{{baseInfo.updateTime}}更新</span>
        </div>

        <div class="statusFun">
            <el-button type="primary" size="mini" @click="openDialog" plain :disabled="status"
                       v-has-permi="['resume:info:status:edit']">更改状态</el-button>
            <!--<el-button type="primary" size="small" round >预览简历</el-button>-->
        </div>

        <el-dialog title="更改状态" :visible.sync="dialogVisible">
            <el-form :model="form">
                <span>完成简历必填项，才可以公开简历呦</span>
                <el-form-item label="公开简历">
                    <!--<el-radio v-model="form.publicStatus" label="true">是</el-radio>-->
                    <!--<el-radio v-model="form.publicStatus" label="false">否</el-radio>-->
                    <el-radio-group v-model="form.publicStatus">
                        <el-radio border :label="true" >是</el-radio>
                        <el-radio border :label="false" >否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="求职状态">
                    <el-select v-model="form.jobStatus" placeholder="请选择">
                        <el-option
                                v-for="item in jobStatusOptions"
                                :key="item.id"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateResumeStatus">更 改</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {updateResumeStatus} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'statusBar', // 简历状态栏
        props: ['baseInfo'],
        data(){
            return{
                dialogVisible: false,
                form: {},
                jobStatusOptions: [],   // 求职状态
            }
        },
        created() {
            this.loadDictData();
        },
        computed: {
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历工作经历编辑状态
            resumeBaseInfoEditStatus(){
                return this.$store.state.index.resumeBaseInfoEditStatus;
            },
            newResumeStatus() {
                return this.$store.state.index.newResumeStatus;
            },
            status() {
                if (this.resumeEditStatus === false && this.resumeBaseInfoEditStatus === false &&this.newResumeStatus === false){
                    return false;
                }else {
                    return true;
                }
            }
        },
        methods: {
            loadDictData(){
                getTreeListByDictType("job_wanted_status").then(response => {
                    this.jobStatusOptions = this.listParseIntByKey(response.data, "value");
                });
            },
            openDialog() {
                this.form = Object.assign({}, this.baseInfo);
                this.dialogVisible = true
            },
            updateResumeStatus(){
                this.dialogVisible = false;
                if (this.form.id) {
                    updateResumeStatus(this.form.id, this.form.publicStatus, this.form.jobStatus).then(res => {
                        this.$message.success("更改成功");
                        this.$store.commit('changeResumeRefreshFlag', true);
                    });
                }else {
                    this.$emit("updateStatus", this.form);
                }
            }
        }
    }
</script>